/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WarnedWord,
    WarnedWordFromJSON,
    WarnedWordFromJSONTyped,
    WarnedWordToJSON,
} from './WarnedWord';

/**
 * 校正結果
 * @export
 * @interface WarningWord200ResponseResultData
 */
export interface WarningWord200ResponseResultData {
    /**
     * タイトルに含まれる校正結果のリスト
     * @type {Array<WarnedWord>}
     * @memberof WarningWord200ResponseResultData
     */
    title?: Array<WarnedWord>;
    /**
     * サブタイトルに含まれる校正結果のリスト
     * @type {Array<WarnedWord>}
     * @memberof WarningWord200ResponseResultData
     */
    subtitle?: Array<WarnedWord>;
    /**
     * リード文に含まれる校正結果のリスト
     * @type {Array<WarnedWord>}
     * @memberof WarningWord200ResponseResultData
     */
    head?: Array<WarnedWord>;
    /**
     * 本文に含まれる校正結果のリスト
     * @type {Array<WarnedWord>}
     * @memberof WarningWord200ResponseResultData
     */
    text?: Array<WarnedWord>;
    /**
     * キャプションに含まれる校正結果のリスト
     * @type {Array<WarnedWord>}
     * @memberof WarningWord200ResponseResultData
     */
    caption?: Array<WarnedWord>;
}

export function WarningWord200ResponseResultDataFromJSON(json: any): WarningWord200ResponseResultData {
    return WarningWord200ResponseResultDataFromJSONTyped(json, false);
}

export function WarningWord200ResponseResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarningWord200ResponseResultData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : ((json['title'] as Array<any>).map(WarnedWordFromJSON)),
        'subtitle': !exists(json, 'subtitle') ? undefined : ((json['subtitle'] as Array<any>).map(WarnedWordFromJSON)),
        'head': !exists(json, 'head') ? undefined : ((json['head'] as Array<any>).map(WarnedWordFromJSON)),
        'text': !exists(json, 'text') ? undefined : ((json['text'] as Array<any>).map(WarnedWordFromJSON)),
        'caption': !exists(json, 'caption') ? undefined : ((json['caption'] as Array<any>).map(WarnedWordFromJSON)),
    };
}

export function WarningWord200ResponseResultDataToJSON(value?: WarningWord200ResponseResultData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title === undefined ? undefined : ((value.title as Array<any>).map(WarnedWordToJSON)),
        'subtitle': value.subtitle === undefined ? undefined : ((value.subtitle as Array<any>).map(WarnedWordToJSON)),
        'head': value.head === undefined ? undefined : ((value.head as Array<any>).map(WarnedWordToJSON)),
        'text': value.text === undefined ? undefined : ((value.text as Array<any>).map(WarnedWordToJSON)),
        'caption': value.caption === undefined ? undefined : ((value.caption as Array<any>).map(WarnedWordToJSON)),
    };
}

